<template>
  <div>
    
  </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
    
    
  },
  data(){
    return {
      code:'',
      local:window.location.href,
      form:{},

    }
  },
  created(){
    document.title = "登录";
    this.getCode();
  },
  methods:{

    getCode(){
      this.code=this.$route.query.code;
      //var code = getUrlParam('code');// 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      console.log(this.code);
      if (this.code == null || this.code == ''||this.code == "undefined") {
        //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+APPID+'&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5a2574cebce0b99c&redirect_uri='+encodeURIComponent(this.local)+'&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
        // window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxdcef53c6bc00eb35&redirect_uri='+encodeURIComponent(this.local)+'&response_type=code&scope=snsapi_login&state=123#wechat_redirect'
        return false;
      } else {
        this.login(); //把code传给后台获取用户信息
        return false;
      }
    },
    login(){
      // this.form.code = this.code
      var that = this;
      this.$http.post('login',{'code':this.code,'parent_userid':localStorage.from_user})
      .then((res)=>{
        
        // this.data = '222222222';
        // console.log(res)
        this.data = res.data.data.token;
        localStorage.token=res.data.data.token;
        localStorage.user_id=res.data.data.user_id;
        // this.$router.go(-2);//返回上一层
        this.$router.push({name:'Appointment'});
      })
      .catch(function (error) {
        // handle error

        // that.code = '';
        that.$router.replace({name:'Login'});
        location. reload()
        return false;
      })

    },

  },
  mounted(){
      if(this.$route.query.from_user){
        localStorage.from_user = this.$route.query.from_user;
      }
  }

}
</script>


